/**
 * Global API Caller function
 * @function
 * @param {RequestBody} => {formData for The APi}
 */

import Cookies from 'universal-cookie';
import apiUrls from './apiUrls';

const cookies = new Cookies();

export const API_URL =
  process.env.REACT_APP_API_URL || apiUrls.apiUrlsObj().allApiUrl;

const APP_ID = 'site_I8xAe15WfY';
const APP_SIGNATURE = 'OlKTU0hEUh8rATbygAT8MZSKNUR90HUVD+f83Zxdogw=';

export default async function apiCaller(
  endpoint,
  method = 'get',
  body,
  keys = false,
  authorization = true,
  isForm = false
) {
  let headers = {
    // Accept: 'application/json, */*',
    'Content-Type': 'application/json'
  };
  if (authorization) {
    headers = {
      ...headers,
      Authorization: `Bearer ${cookies.get('jwt') || window.jwt} ${cookies.get(
        'globalId'
      )}`
      // Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJnbG9iYWxJZCI6IjEiLCJpYXQiOjE1MjU3NzA1NTB9.WEd4Uo3gEgtv_-lkY_u6SQ8UX26VLgm_GtdoeLdh2UI`
    };
  }
  let options = {
    headers,
    method
  };

  const data = keys
    ? { ...body, app_id: APP_ID, app_signature: APP_SIGNATURE }
    : { ...body };

  if (method !== 'get' && !isForm) {
    options = {
      ...options,
      body: JSON.stringify(data)
    };
  }
  if (isForm) {
    const form = new FormData();
    options.headers['Content-Type'] =
      'application/x-www-form-urlencoded;charset=UTF-8';
    Object.keys(body).forEach(key => {
      form.append(key, body[key]);
    });
    options = {
      ...options,
      body: form
    };
  }
  try {
    const response = await fetch(`${API_URL}/${endpoint}`, options);
    // console.log('response - ', response);
    return response.json();
  } catch (error) {
    console.log('error - ', error);
    return error;
  }
  // .then(response => response.json());
  // .catch(error => error);
}
